import styled from "styled-components";

export const Label = styled.label `
    background: #fff;
    color: #bbb;
    font-size: 1.4rem;
    padding: 0.5rem;
    position: relative;
    top: 0.9rem;
    left: 1.4rem;
    z-index: 2;
`;